import { useMutation } from "@tanstack/react-query";
import { CustomerModelBulkItemModel } from "src/models/relationshipmanagement";
import { bulkPatchCustomerProfiles } from "src/services/relationshipmanagement";

export function chunkRequests(array: any[], size: number) {
  const result = [];
  let pos = 0;
  while (pos < array.length) {
    result.push(array.slice(pos, pos + size));
    pos += size;
  }

  return result;
}

export const useCommonUIFlowMutations = () => {
  const assignCustomersMutation = useMutation({
    mutationFn: async (data: CustomerModelBulkItemModel[]) => {
      if (data.length > 0) {
        const chunkedRequests = chunkRequests(data, 50);

        for (let chunkedDataIndex = 0; chunkedDataIndex < chunkedRequests.length; chunkedDataIndex++) {
          await bulkPatchCustomerProfiles(chunkedRequests[chunkedDataIndex])
        }
      }
    }
  });

  return { assignCustomersMutation };
}
